import { FC, useState } from "react";
import { SectionTitle } from "../styles";
import { TdInput } from "../components/Inputs/TdInput";
import { useTranslation } from "react-i18next";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint } from "@brg/ui";
import { Lang } from "@brg/api";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import setTextByLang from "shared/helpers/setTextByLang";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import { LangObject, LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { LayoutConst } from "core";

const NameEditor: FC = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
  const dispatch = useDispatch();
  const { header, description } = useSelector(ApplicationEditorSelector);
  const action = ApplicationEditorActions;

  const handleHeaderChange = (ev: any, lang: string) => {
    dispatch(action.setHeader(setTextByLang(header, lang, ev.target.value)));
  };

  const handleDescriptionChange = (ev: any, lang: string) => {
    dispatch(action.setDescription(setTextByLang(description, lang, ev.target.value)));
  };

  return (
    <FlexBox gy={24} direction="column">
      <CommonInput
          type={INPUT_TYPES.text}
          value={header}
          useLangSwitcher
          orientation="row"
          label={t("applicationEditor.sections.fields.label.name")}
          placeholder={t("applicationEditor.sections.fields.placeholder.name")}
          onChange={(ev: any, lang?: string) => handleHeaderChange(ev, lang ?? i18n.language)}
      />
      <CommonInput
        type={INPUT_TYPES.textarea}
        value={description}
        useLangSwitcher
        orientation="row"
        minHeight={isMobile ? 60 : 148}
        label={t("applicationEditor.sections.fields.label.description")}
        placeholder={t("applicationEditor.sections.fields.placeholder.description")}
        onChange={(ev: any, lang?: string) => handleDescriptionChange(ev, lang ?? i18n.language)}
      />
    </FlexBox>
  );
};

export default NameEditor;import { FC, useState } from "react";
import { SectionTitle } from "../styles";
import { TdInput } from "../components/Inputs/TdInput";
import { useTranslation } from "react-i18next";
import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint } from "@brg/ui";
import { Lang } from "@brg/api";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import setTextByLang from "shared/helpers/setTextByLang";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import { LangObject, LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { LayoutConst } from "core";

const NameEditor: FC = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
  const dispatch = useDispatch();
  const { header, description } = useSelector(ApplicationEditorSelector);
  const action = ApplicationEditorActions;

  const handleHeaderChange = (ev: any, lang: string) => {
    dispatch(action.setHeader(setTextByLang(header, lang, ev.target.value)));
  };

  const handleDescriptionChange = (ev: any, lang: string) => {
    dispatch(action.setDescription(setTextByLang(description, lang, ev.target.value)));
  };

  return (
    <FlexBox gy={24} direction="column">
      <CommonInput
          type={INPUT_TYPES.text}
          value={header}
          useLangSwitcher
          orientation="row"
          label={t("applicationEditor.sections.fields.label.name")}
          placeholder={t("applicationEditor.sections.fields.placeholder.name")}
          onChange={(ev: any, lang?: string) => handleHeaderChange(ev, lang ?? i18n.language)}
      />
      <CommonInput
        type={INPUT_TYPES.textarea}
        value={description}
        useLangSwitcher
        orientation="row"
        minHeight={isMobile ? 60 : 148}
        label={t("applicationEditor.sections.fields.label.description")}
        placeholder={t("applicationEditor.sections.fields.placeholder.description")}
        onChange={(ev: any, lang?: string) => handleDescriptionChange(ev, lang ?? i18n.language)}
      />
    </FlexBox>
  );
};

export default NameEditor;